import { loaderWrapper } from "./TopLoader.css"

const TopLoader = () => {
  return <div className={loaderWrapper}></div>
}

export default TopLoader
